// extracted by mini-css-extract-plugin
export default {"loading":"downloadApp_loading__LzUVW","pcWrap":"downloadApp_pcWrap__FGKZX"};